import React, { useEffect, useState } from 'react';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import {
  getOrganizationDetails,
  updateDetails
} from 'nursd-dashboard/api/organizationTable';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import { Card, Row } from 'react-bootstrap';
import Create_Location from './create_location';
import { toast } from 'react-toastify';
import LocationTable from './table/LocationTable';

function ManageLocation() {
  const { authToken, userId } = useAuth();
  const [organization, setOrganization] = useState(undefined);
  const [loadingScreen, setLoadingScreen] = useState(true);
  const [addRecord, setAddRecord] = useState(false);
  const [newLocation, setNewLocation] = useState({
    location_id: '',
    location_city: '',
    location_state: '',
    location_country: '',
    location_zipCode: 0,
    location_fullAddress: '',
    latitude: '',
    longitude: ''
  });

  const getOrgLocationList = async () => {
    setLoadingScreen(true);
    await getOrganizationDetails(authToken, userId)
      .then(res => {
        if (res) {
          setOrganization(res);
          setLoadingScreen(false);
        }
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {
    getOrgLocationList();
  }, [authToken, userId]);

  const handleInputChangeNewData = event => {
    setNewLocation(prevState => {
      return { ...prevState, [event.target.name]: event.target.value };
    });
  };

  const updateLocation = async () => {
    try {
      await updateDetails(authToken, userId, {
        // eslint-disable-next-line no-unsafe-optional-chaining
        locations: [...organization?.locations, newLocation]
      })
        .then(() => {
          toast.success(
            `New ${newLocation?.location_id} Location added successfully.`,
            {
              theme: 'colored'
            }
          );
          setNewLocation({
            location_id: '',
            location_city: '',
            location_state: '',
            location_country: '',
            location_zipCode: 0,
            location_fullAddress: '',
            latitude: '',
            longitude: ''
          });
          setAddRecord(false);
          getOrgLocationList();
        })
        .catch(e => {
          console.log(e);
        });
    } catch (error) {
      console.log('data save error:', error);
    }
  };

  return (
    <>
      {loadingScreen ? (
        <Card>
          <p className="m-3">Loading...</p>
        </Card>
      ) : (
        <Card>
          <Card.Header className="bg-body-tertiary">
            <Flex className="mb-3" alignItems={'center'}>
              <h5>{organization?.organizationName}</h5>
              {!addRecord && (
                <IconButton
                  variant="success"
                  iconClassName="me-2"
                  icon="plus"
                  size="sm"
                  className="mx-3"
                  onClick={() => setAddRecord(true)}
                >
                  <span className="text-light ms-1">Location</span>
                </IconButton>
              )}
            </Flex>
            <h6 className="mb-2">Phone Number = {organization?.phoneNumber}</h6>
            <h6 className="mb-2">Main Branch = {organization?.mainBranch}</h6>
            <h6 className="mb-2">Address = {organization?.fullAddress}</h6>
          </Card.Header>
          <Card.Body className="bg-body-tertiary">
            {addRecord ? (
              <div className="flex-1 mx-5">
                <Create_Location
                  newLocation={newLocation}
                  handleInputChangeNewData={handleInputChangeNewData}
                  updateLocation={updateLocation}
                  setAddRecord={setAddRecord}
                  setNewLocation={setNewLocation}
                />
              </div>
            ) : (
              <Row>
                {/* {organization?.locations?.map((item, index) => {
                  return (
                    <Col key={index} md="3" className="mt-2">
                      <Card onClick={() => openMap(item?.location_fullAddress)}>
                        <Card.Header className="bg-body-tertiary">
                          <iframe
                            width="100%"
                            height="250"
                            loading="lazy"
                            src={`https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d10!2d${item?.longitude}!3d${item?.latitude}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1645431513458`}
                            title="Google Maps"
                          ></iframe>
                        </Card.Header>
                        <Card.Body className="bg-body-tertiary">
                          <h6 className="mb-2">{item?.location_id}</h6>
                          <h6 className="mb-2">{item?.location_fullAddress}</h6>
                        </Card.Body>
                      </Card>
                    </Col>
                  );
                })} */}
                <LocationTable data={organization?.locations} />
              </Row>
            )}
          </Card.Body>
        </Card>
      )}
    </>
  );
}

export default ManageLocation;
